import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef, type PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '~/chords/IconButton';

export const SlideOutHeader = forwardRef<
  HTMLDivElement,
  PropsWithChildren<{ showCloseButton?: boolean }>
>(({ children, showCloseButton = true, ...props }, ref) => {
  const { t } = useTranslation('common');

  return (
    <div ref={ref} {...props} className="flex justify-between p-lg pb-md">
      <Dialog.Title className="text-headline-md font-bold">
        {children}
      </Dialog.Title>
      {showCloseButton ? (
        <div className="-mr-sm -mt-sm">
          <Dialog.Close asChild>
            <IconButton
              type="button"
              iconType="xmark"
              iconVariant="regular"
              size="large"
              aria-label={t('closePanel')}
            />
          </Dialog.Close>
        </div>
      ) : null}
    </div>
  );
});

SlideOutHeader.displayName = 'SlideOut.Header';
